<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  itemKey: string;
  displayValue: string;
  modelValue: string | boolean | number;
  // Value currently used by config
  currentValue: string | boolean | number;
  // Value from base config layer
  baseValue: string | boolean | number;
  readOnly: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | boolean | number): void;
}>();

const value = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit('update:modelValue', newValue);
  },
});

const inputType = typeof props.modelValue === 'boolean' ? 'checkbox' : 'text';
</script>

<template>
  <div class="py-2">
    <div class="mb-3">
      <label class="text-xs font-bold text-gray-900" :for="`${itemKey}-input`"
        >{{ displayValue }}
        <span
          class="text-indigo-600 select-none"
          v-if="modelValue !== baseValue && modelValue === currentValue && !props.readOnly"
          >Non-default</span
        >
        <span class="text-indigo-600 select-none" v-if="modelValue !== currentValue"
          >Not saved</span
        >
      </label>
      <p class="text-xs font-bold break-words text-gray-500">
        <span class="select-none" v-if="!props.readOnly">default: {{ baseValue }}</span>
        <span class="select-none" v-else>read only</span>
      </p>
    </div>
    <input
      :name="`${itemKey}-input`"
      :data-test="`${itemKey}-input`"
      class="block rounded-lg border border-gray-300 bg-white text-gray-900 outline-none"
      autocomplete="false"
      :class="{
        'h-12 w-full px-4 text-sm': inputType === 'text',
        'h-6 w-6 cursor-pointer px-0': inputType === 'checkbox',
      }"
      :type="inputType"
      v-model="value"
      :disabled="props.readOnly"
    />
  </div>
</template>
